
//items 2 rebix k kaam ka hay
const items2 = [
  {
    id: 1,
    image: "1.jpg",
    title: "Primero Avionics",
    tagline: "Web Development",
    filter: ["all", "web-development"],
  },
  {
    id: 2,
    image: "2.jpg",
    title: "The Datayard",
    tagline: "Web Development",
    filter: ["all", "web-development", "wordpress"],
  },
  {
    id: 3,
    image: "5.jpg",
    title: "The Datayard - Plugin",
    tagline: "Plugin Development",
    filter: ["all", "web-development", "plugin-development"],
  },
  {
    id: 4,
    image: "6.jpg",
    title: "Salezman App",
    tagline: "Mobile Development",
    filter: ["all", "mobile-development", "prototype"],
  },
  {
    id: 5,
    image: "8.jpg",
    title: "BP- Yard",
    tagline: "Mobile Development",
    filter: ["all", "mobile-development", "prototype"],
  },
  {
    id: 6,
    image: "9.jpg",
    title: "Jooble",
    tagline: "Mobile Development",
    filter: ["all", "mobile-development", "prototype"],
  },
  {
    id: 7,
    image: "7.jpg",
    title: "Expense Diaries",
    tagline: "Mobile Development",
    filter: ["all", "mobile-development", "prototype"],
  },
  {
    id: 8,
    image: "10.jpg",
    title: "Test Signup-Login",
    tagline: "Mobile Development",
    filter: ["all", "mobile-development"],
  },
  {
    id: 9,
    image: "3.jpg",
    title: "Movie Finder",
    tagline: "Web Development",
    filter: ["all", "web-development"],
  },
  {
    id: 10,
    image: "4.jpg",
    title: "Teach Mate",
    tagline: "Web Development",
    filter: ["all", "web-development"],
  },
  {
    id: 11,
    image: "11.jpg",
    title: "Cuirderi",
    tagline: "shopify",
    filter: ["all", "shopify"],
  },
  {
    id: 12,
    image: "12.jpg",
    title: "Safe Kiddo Gear",
    tagline: "shopify",
    filter: ["all", "shopify"],
  },
  {
    id: 13,
    image: "13.jpg",
    title: "Kustom Neons Falkrik",
    tagline: "shopify",
    filter: ["all", "shopify"],
  },
  {
    id: 14,
    image: "14.jpg",
    title: "The Yoga Tree",
    tagline: "shopify",
    filter: ["all", "shopify"],
  },
  {
    id: 15,
    image: "15.jpg",
    title: "Luca Danni",
    tagline: "shopify",
    filter: ["all", "shopify"],
  },
  {
    id: 16,
    image: "16.jpg",
    title: "Blue Light Barrier",
    tagline: "shopify",
    filter: ["all", "shopify"],
  },
  {
    id: 17,
    image: "17.jpg",
    title: "Experience Fresh",
    tagline: "wordpress",
    filter: ["all", "wordpress"],
  },
  {
    id: 18,
    image: "18.jpg",
    title: "Navion Senior Solutions",
    tagline: "wordpress",
    filter: ["all", "wordpress"],
  },
  {
    id: 19,
    image: "19.jpg",
    title: "CarterCo Plumbing",
    tagline: "wordpress",
    filter: ["all", "wordpress"],
  },
  {
    id: 20,
    image: "20.jpg",
    title: "Zayra Dental",
    tagline: "wordpress",
    filter: ["all", "wordpress"],
  },
  {
    id: 21,
    image: "21.jpg",
    title: "Fast Line Insurance",
    tagline: "wordpress",
    filter: ["all", "wordpress"],
  },
  {
    id: 22,
    image: "22.jpg",
    title: "Bubble Games",
    tagline: "wordpress",
    filter: ["all", "wordpress"],
  },
  {
    id: 23,
    image: "23.jpg",
    title: "Bancroft Construction",
    tagline: "wordpress",
    filter: ["all", "wordpress"],
  },
  {
    id: 24,
    image: "24.jpg",
    title: "Attendance Management System",
    tagline: "Prototype",
    filter: ["all", "prototype"],
  },
  {
    id: 25,
    image: "26.jpg",
    title: "Humsafar Forever Love",
    tagline: "Web Development",
    filter: ["all", "web-development"],
  },
  {
    id: 26,
    image: "27.jpg",
    title: "Quantumnexa",
    tagline: "Web Development",
    filter: ["all", "web-development"],
  },
  {
    id: 27,
    image: "28.jpg",
    title: "Genvita",
    tagline: "shopify",
    filter: ["all", "shopify"],
  },
  {
    id: 28,
    image: "29.jpg",
    title: "Abzai",
    tagline: "shopify",
    filter: ["all", "shopify"],
  },
  {
    id: 29,
    image: "25.jpg",
    title: "MB Enterprize",
    tagline: "Web Development",
    filter: ["all", "web-development"],
  },
  {
    id: 30,
    image: "31.jpg",
    title: "BN Traders",
    tagline: "shopify",
    filter: ["all", "shopify"],
  },
  {
    id: 31,
    image: "32.jpg",
    title: "Luxxesh",
    tagline: "shopify",
    filter: ["all", "shopify"],
  },
  {
    id: 32,
    image: "33.jpg",
    title: "Whitening Recipe",
    tagline: "shopify",
    filter: ["all", "shopify"],
  },
  {
    id: 33,
    image: "30.jpg",
    title: "Elara",
    tagline: "shopify",
    filter: ["all", "shopify"],
  },
  {
    id: 34,
    image: "34.jpg",
    title: "Chanova Design",
    tagline: "wix",
    filter: ["all", "wix"],
  },
  {
    id: 35,
    image: "35.jpg",
    title: "Guardisse",
    tagline: "wix",
    filter: ["all", "wix"],
  },
  {
    id: 36,
    image: "36.jpg",
    title: "Contractor Supply Co.",
    tagline: "wordpress",
    filter: ["all", "wordpress"],
  },
];

  

// const gallerySection = {
//   title: "Our work showcase",
//   tabBtns: [
//     {
//       id: 1,
//       name: "All",
//       tab: "p-tab-1",
//       count: 6,
//     },
//     {
//       id: 2,
//       name: "Branding",
//       tab: "p-tab-2",
//       count: 8,
//     },
//     {
//       id: 3,
//       name: "illustration",
//       tab: "p-tab-3",
//       count: 7,
//     },
//     {
//       id: 4,
//       name: "Photography",
//       tab: "p-tab-4",
//       count: 10,
//     },
//     {
//       id: 5,
//       name: "Web Design",
//       tab: "p-tab-5",
//       count: 9,
//     },
//   ],
//   pTabs: [
//     {
//       id: "p-tab-1",
//       items,
//     },
//     {
//       id: "p-tab-2",
//       items,
//     },
//     {
//       id: "p-tab-3",
//       items,
//     },
//     {
//       id: "p-tab-4",
//       items,
//     },
//     {
//       id: "p-tab-5",
//       items,
//     },
//   ],
//   pTabs2: [
//     {
//       id: "p-tab-1",
//       items: items3,
//     },
//     {
//       id: "p-tab-2",
//       items: items3,
//     },
//     {
//       id: "p-tab-3",
//       items: items3,
//     },
//     {
//       id: "p-tab-4",
//       items: items3,
//     },
//     {
//       id: "p-tab-5",
//       items: items3,
//     },
//   ],
// };

// export default gallerySection;

export const gallerySectionOne = {
  title: "work showcase",
  tabBtns: [
    {
      id: 1,
      name: "All",
      tab: "all",
    },
    {
      id: 2,
      name: "Web Development",
      tab: "web-development",
    },
    {
      id: 3,
      name: "Mobile Application",
      tab: "mobile-development",
    },

    {
      id: 4,
      name: "Plugin Development",
      tab: "plugin-development",
    },
    {
      id: 5,
      name: "WordPress",
      tab: "wordpress",
    },
    {
      id: 6,
      name: "Shopify",
      tab: "shopify",
    },
    {
      id: 7,
      name: "Wix",
      tab: "wix",
    },

  ],
  items: items2,
};

export const gallerySectionThree = {
  tagline: "What We did",
  title: "Latest Projects",
  items: [
    {
      id: 1,
      image: "project-1-1.jpg",
      tagline: "Project List",
      title: "Substantial Growth",
    },
    {
      id: 2,
      image: "project-1-2.jpg",
      tagline: "Project List",
      title: "Substantial Growth",
    },
    {
      id: 3,
      image: "project-1-3.jpg",
      tagline: "Project List",
      title: "Substantial Growth",
    },
    {
      id: 4,
      image: "project-1-4.jpg",
      tagline: "Project List",
      title: "Substantial Growth",
    },
    {
      id: 5,
      image: "project-1-5.jpg",
      tagline: "Project List",
      title: "Substantial Growth",
    },
    {
      id: 6,
      image: "project-1-6.jpg",
      tagline: "Project List",
      title: "Substantial Growth",
    },
  ],
};
